import { Badge } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';
import type { PersonaDto } from '@/lib/api/personas-client';

export type AudienceCreationStatus = NonNullable<PersonaDto['creationStatus']>;

const DEFAULT_STATUS: AudienceCreationStatus = 'ready';

const STATUS_CONFIG = {
  ready: { labelKey: 'audiences.audienceStatusChip.ready', variant: 'positive' },
  processing: { labelKey: 'audiences.audienceStatusChip.inProgress', variant: 'warning' },
  failed: { labelKey: 'audiences.audienceStatusChip.failed', variant: 'destructive' },
} as const satisfies Record<
  AudienceCreationStatus,
  { labelKey: string; variant: 'positive' | 'warning' | 'secondary' | 'destructive' }
>;

interface AudienceStatusChipProps {
  status?: PersonaDto['creationStatus'];
}

export const AudienceStatusChip = ({ status = DEFAULT_STATUS }: AudienceStatusChipProps) => {
  const { t } = useTranslation('audiences');
  const config = STATUS_CONFIG[status];

  return (
    <Badge variant={config.variant} roundness="full">
      {t(config.labelKey)}
    </Badge>
  );
};
